import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { AthleteStatus, AthleteStatusWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateAthleteStatus(): UseMutationResult<
  AxiosResponse<AthleteStatus>,
  AxiosError<ErrorMessage>,
  AthleteStatusWrite
> {
  const queryClient = useQueryClient();

  const createAthleteStatus = (athleteStatus: AthleteStatusWrite): Promise<AxiosResponse<AthleteStatus>> => {
    return client.post('athlete-statuses/', athleteStatus);
  };

  return useMutation(createAthleteStatus, {
    onSuccess: response => {
      queryClient.invalidateQueries({
        queryKey: ['athleteStatuses'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athletes', response.data.athlete],
      });
    },
  });
}
